/**
 * Cornerstone adapters events
 */
export enum Events {
  /**
   * Cornerstone segmentation load progress event
   */
  SEGMENTATION_LOAD_PROGRESS = 'CORNERSTONE_ADAPTER_SEGMENTATION_LOAD_PROGRESS',
}

export default Events;
